export default function toggleModal() {
  console.log('I am loading - Simple Modal.')
  // Get each modal and close button.
  const triggers = document.getElementsByClassName("modal-trigger");
  const triggerArray = Array.from(triggers).entries();
  const modals = document.getElementsByClassName("modal-item");
  const closeButtons = document.getElementsByClassName("modal-close");

  // Then use `for...of`-loop with the index of each item in `triggerArray` for
  // listening to a click event which toggles each modal to open and close.
  for (let [index, trigger] of triggerArray) {
    const toggleModal = () => {
      /**
       * GeoLocation Trigger - Ensure 'Button' is visible.
       *
       * - If button not present (due to previous removal), re-add button.
       */
      let modalTrigger = document.getElementById('modal-geotrigger');
      modalTrigger.style.display = "block";
      let locationPending = document.getElementById('geolocation-pending');
      locationPending.style.display = "none";
      
      // Using '0' instead of 'index' so the 'Open Modal' trigger works from every button.
      modals[0].classList.toggle("open-modal");
    };
    trigger.addEventListener("click", toggleModal);
    closeButtons[index].addEventListener("click", toggleModal);
  }
}